import React, { useState, useEffect } from "react";
import {
  Box,
  Stepper,
  Step,
  StepButton,
  Button,
  Typography,
  StepLabel,
  Paper,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import VendorStep from "./VendorStep";
import StoreStep from "./StoreStep";
import StoreMetaStep from "./StoreMetaStep"; // New meta step
import ServiceStep from "./ServiceStep";
import SummaryStep from "./SummaryStep";
import NewStoreCreated from "./NewStoreCreated";
import PageHeader from "../../../components/page-layout/PageHeader";

import RewardMusic from '../../../assets/musics/reward.mp3';

// Steps configuration: added Store Meta Information after Store Information
const stepsConfig = [
  {
    label: "Vendor Information",
    Component: VendorStep,
    disabled: false,
    leadContent: "Fill in the vendor's details to get started.",
  },
  {
    label: "Store Information",
    Component: StoreStep,
    disabled: true,
    leadContent: "Enter the store's details and location.",
  },

  //test
  
  {
    label: "Store Meta Information",
    Component: StoreMetaStep,
    disabled: true,
    leadContent: "Provide store meta details as per specification.",
  },
  {
    label: "Service Selection",
    Component: ServiceStep,
    disabled: true,
    leadContent: "Choose the services offered by this store.",
  },
  {
    label: "Review & Confirm",
    Component: SummaryStep,
    disabled: true,
    leadContent: "Review all information before submitting.",
  },
  {
    label: "Store Created",
    Component: NewStoreCreated,
    disabled: true,

    leadContent: "New store has been successfully created!",
  }
];
export default function StoreStepper() {
  const navigate = useNavigate();
  const location = useLocation();

  const [steps, setSteps] = useState(stepsConfig);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [formData, setFormData] = useState({});

  console.log({formData })

  // Reset if navigated here with state.reset
  useEffect(() => {
    if (location.state?.reset) {
      handleReset();
      // clear the flag so it doesn’t trigger again
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  const totalSteps = steps.length;

  const handleStepClick = (index) => {
    // Only allow clicking on completed steps
    if (completed[index]) {
      setActiveStep(index);
    }
  };

  const nextStep = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setCompleted((prev) => ({ ...prev, [activeStep]: true }));
    if (activeStep < totalSteps - 1) {
      setSteps((prev) => 
        prev.map((s, i) => ({ ...s, disabled: i > activeStep + 1 }))
      );
      setActiveStep(activeStep + 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
    setFormData({});
    // Reset disabled flags
    setSteps(stepsConfig.map((s, idx) => ({ ...s, disabled: idx > 0 })));
  };

  const ActiveComponent = steps[activeStep].Component;


    const [audioEl, setAudioEl] = useState(null);
   useEffect(() => {
    const audio = document.createElement("audio");
    audio.src = RewardMusic;
    setAudioEl(audio);
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, []);
  const playAudio = () => {
    audioEl && audioEl.play().catch(() => {});
  };


  return (
    <Box>
      <PageHeader title="Add Store" showBack />
      <Stepper activeStep={activeStep} nonLinear>
        {steps.map((step, index) => (
          <Step key={step.label} completed={!!completed[index]}>
            <StepLabel optional={step.leadContent}>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Paper elevation={2} sx={{ borderRadius: 2, mt: 4, overflow: 'hidden' }}>
        <Box p={2} sx={{
            background: "linear-gradient(to top,rgba(255,213,0,0.11) 0%,rgba(255,255,255,0) 20%)"
        }}>
          {Object.keys(completed).length === totalSteps ? (
            <Box textAlign="center">
              <Typography>All steps completed!</Typography>
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          ) : (
            <ActiveComponent
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              stepHandler={setActiveStep}
              onBack={
                activeStep > 0 ? () => setActiveStep(activeStep - 1) : null}
              onFinal={playAudio}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
}
